import React from "react";
import { Icon } from "@chakra-ui/react";

/**
 * Renders the standard plugin icon
 * 
 * @param {Object} props - The props of the component
 * @returns The standard plugin icon
 */
const StandardPluginIcon = (props) => (
  <Icon viewBox="0 0 40 40" fill="none" {...props}>
    <rect x="25" y="6" width="9" height="28" rx="2" stroke="currentColor" stroke-width="2" />
  </Icon>
);

export default React.memo(StandardPluginIcon);
